import { FunctionComponent, useState } from 'react'
import { useAuth } from '@/modules/context/AuthContext'
import SuggestHeader from './suggestHeader'
import styles from './suggest.module.scss'
import { Role } from '@/types/Role'
import { DaycareType } from '@/types/Daycare'
import SuggestParentTable from './suggestTable/suggestParentTable/suggestParentTable'
import SuggestStaffTable from './suggestTable/suggestStaffTable/suggestStaffTable'
import { Navigate } from 'react-router-dom'

const SuggestPage: FunctionComponent = () => {
    const { user } = useAuth()

    const [switchTab, setSwitchTab] = useState<number>(0)

    const showAssMat: boolean =
        user?.role === Role.cald ||
        user?.role === Role.trustee ||
        (user?.role === Role.staff && user.currentDaycare?.type === DaycareType.rpe)

    return user?.role &&
        user.currentDaycare &&
        user.currentDaycareRights &&
        user.currentDaycareRights.hasSuggestAccess &&
        user.currentDaycareRights.canReadSuggestions ? (
        <div className={styles.PagePosition}>
            <div className={styles.Header}>
                <SuggestHeader switchTab={switchTab} setSwitchTab={setSwitchTab} showAssMat={showAssMat} />
            </div>
            {switchTab === 0 || (switchTab === 1 && showAssMat) ? (
                <SuggestParentTable switchTab={switchTab} showAssMat={showAssMat} />
            ) : (
                <SuggestStaffTable />
            )}
        </div>
    ) : (
        <Navigate to='/' replace />
    )
}

export default SuggestPage
